import { FASTElement } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { debounce } from 'lodash-es';
import { Menu } from '@microsoft/fast-foundation';
export class FASTElementHeightOverflowObserver extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super();
        this.observerCallback = debounce((entries) => {
            entries.forEach((entry) => this.handleElementHeightOverflow(entry.target));
        }, 200);
        this.observer = new ResizeObserver(this.observerCallback);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observerCallback.cancel();
        this.observer.disconnect();
    }
}
export class NavigationRailHeightOverflowObserver extends ChameleonElementMixin(Menu) {
    constructor() {
        super();
        this.observerCallback = debounce((entries) => {
            entries.forEach((entry) => this.handleElementHeightOverflow(entry.target));
        }, 200);
        this.observer = new ResizeObserver(this.observerCallback);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observerCallback.cancel();
        this.observer.disconnect();
    }
}
